import React from "react";
import { Typography } from "@mui/material";

import { StyledLabelStack } from "./styles";

export const WorkOrderLabel = ({
  label = "",
  value = "",
  valueBold = false,
  underlined = false,
  c1 = "100px",
  autoSpacing = false,
  ...rest
}) => {
  const valueSx = underlined ? { borderBottom: "1px solid" } : {};
  const useAuto = valueBold || underlined;
  const fontSize = "11px";

  return (
    <StyledLabelStack c1={useAuto || autoSpacing ? "auto" : c1} {...rest}>
      <Typography
        variant="boldCaption"
        fontWeight={400}
        lineHeight="14px"
        fontSize={fontSize}
      >
        {label}:
      </Typography>
      <Typography
        variant={valueBold ? "boldCaption" : "caption"}
        className="WorkOrderLabel-root"
        lineHeight="14px"
        sx={valueSx}
        fontSize={fontSize}
        noWrap
      >
        {value}
      </Typography>
    </StyledLabelStack>
  );
};

export default WorkOrderLabel;
